import { Payment, useWatchForTransaction } from "@/api/payment-pages"
import PayReceipt from "./pay-receipt"
import PayForm from "./pay.form"
import ArrowLeftIcon from "@/components/icons/arrow-left"
import { Link } from "@/components/ui/link"
import DownloadReceiptLink from "./download-receipt.link"
import { Card, CardContent } from "@/components/ui/card"

interface PayFlowProps {
  shortId: string;
  payment: Payment;
}

export default function PayFlow({ shortId, payment }: PayFlowProps) {
  const transaction = useWatchForTransaction(shortId, payment.id)

  if (!transaction) {
    return (
      <div className="flex flex-col items-center gap-8">
        <Card className="shadow-md">
          <CardContent>
            <div className="flex flex-col items-center gap-3">
              <h2 className="text-xl font-semibold text-gray-300 justify-center text-wrap flex gap-1 flex-wrap">
                Sending
                <strong className="text-black">{payment.token}</strong>
                using
                <strong className="text-black">{payment.network}</strong>
                network
              </h2>
              <p className="text-gray-300 text-center text-sm">
                Scan the QR code or copy the {payment.token} address to make a
                payment.
              </p>
              <PayForm
                address={payment.address}
                amount={payment.amount}
                token={payment.token}
                network={payment.network}
              />
            </div>
          </CardContent>
        </Card>
        <Link
          to={`/${shortId}`}
          className="text-blue-500 font-semibold text-sm"
        >
          <ArrowLeftIcon />
          Go back
        </Link>
      </div>
    )
  } else {
    return (
      <div className="flex flex-col gap-6 items-center">
        <PayReceipt transaction={transaction} />
        <DownloadReceiptLink shortId={shortId} paymentId={payment.id} />
      </div>
    )
  }
}
